import { EffectFade } from 'swiper';
import SwiperSlider from '../base';

const selectors = {
  sliderEl: '[data-comp-slideshow]',
  pagination: '[data-slideshow="pagination"]',
};

const swiperOptions = {
  spaceBetween: 30,
  effect: 'fade',
  preventClicks: false,
  preventClicksPropagation: false,
  fadeEffect: {
    crossFade: true,
  },
  autoplay: {
    delay: 8000,
  },
  speed: 1000,
};

export default class Slideshow extends SwiperSlider {
  static selector = selectors.sliderEl;

  constructor(containerEl) {
    super(containerEl);
    this.Swiper.use([EffectFade]);

    this.generalSlider = new this.Swiper(
      this.$container,
      swiperOptions,
    );
    triggerWindowResize(); // Trigger window resize after timeout to correct visual errors
  }
}

function triggerWindowResize() {
  window.setTimeout(() => window.dispatchEvent(new Event('resize')), 500);
}
